<template>
  <div class="wrapper">
    <header :class="['main-header', $store.getters.env]">
      <a href="/home" class="logo">
        <span class="logo-mini">
          <img class="img-responsive center-block" src="/static/img/logo-mini.svg" />
        </span>
        <span class="logo-lg">
          <img
            id="logo"
            :class="checkEnv() ? 'img-responsive center-block': 'img-responsive center-block logo-st'"
            :src="checkEnv() ? '/static/img/logo-lg.svg': '/static/img/staging.svg'"
          />
        </span>
      </a>
      <nav class="navbar navbar-static-top" role="navigation">
        <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
          <span class="sr-only">Toggle navigation</span>
        </a>
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <li class="dropdown messages-menu">
              <a href="javascript:;" class="dropdown-toggle">
                <i class="fa fa-envelope-o"></i>
                <span class="label label-success"></span>
              </a>
              <ul class="dropdown-menu">
                <li class="header"></li>
                <li v-if="state.userInfo && state.userInfo.messages.length > 0">
                  <ul class="menu">
                    <li>
                      <a href="javascript:;">
                        <h4>
                          Support Team
                          <small>
                            <i class="fa fa-clock-o"></i> 5 mins
                          </small>
                        </h4>
                        <p>Why not consider this a test message?</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="footer" v-if="state.userInfo && state.userInfo.messages.length > 0">
                  <a href="javascript:;">See All Messages</a>
                </li>
              </ul>
            </li>
            <li class="dropdown notifications-menu">
              <a href="javascript:;" class="dropdown-toggle">
                <i class="fa fa-bell-o"></i>
                <span class="label label-warning"></span>
              </a>
              <ul class="dropdown-menu">
                <li class="header"></li>
                <li v-if="state.userInfo && state.userInfo.notifications.length > 0">
                  <ul class="menu">
                    <li>
                      <a href="javascript:;">
                        <i class="fa fa-users text-aqua"></i> 5 new members joined today
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="footer" v-if="state.userInfo && state.userInfo.notifications.length > 0">
                  <a href="javascript:;">View all</a>
                </li>
              </ul>
            </li>
            <li class="dropdown tasks-menu">
              <a href="javascript:;" class="dropdown-toggle">
                <i class="fa fa-flag-o"></i>
                <span class="label label-danger"></span>
              </a>
              <ul class="dropdown-menu">
                <li class="header"></li>
                <li v-if="state.userInfo && state.userInfo.tasks.length > 0">
                  <ul class="menu">
                    <li>
                      <a href="javascript:;"></a>
                    </li>
                  </ul>
                </li>
                <li class="footer" v-if="state.userInfo && state.userInfo.tasks.length > 0">
                  <a href="javascript:;">View all tasks</a>
                </li>
              </ul>
            </li>
            <li></li>
            <li class="dropdown user user-menu">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <img :src="'/static/img/' + user_image" class="user-image" alt="User Image" />
                <span class="hidden-xs">{{ user.company }}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="user-header">
                  <img :src="'/static/img/' + user_image" class="img-circle" alt="User Image" />
                  <p>
                    {{ user.first_name + ' ' + user.last_name }}
                    <small>{{user.username}}</small>
                  </p>
                </li>
                <li class="user-body">
                  <div class="row">
                    <div class="col-xs-12 text-center">
                      <div class="btn-group">
                        <button
                          type="button"
                          class="btn disabled"
                        >{{'language' | translate(language) }}</button>
                        <button
                          type="button"
                          :class="[{active: language == 'de'}, 'btn']"
                          @click.prevent="changeLanguage('de')"
                        >
                          <img
                            class="center-block"
                            src="/static/img/de.png"
                            alt="German"
                            title="Change Language"
                          />
                        </button>
                        <button
                          type="button"
                          :class="[{active: language == 'en'}, 'btn']"
                          @click.prevent="changeLanguage('en')"
                        >
                          <img
                            class="center-block"
                            src="/static/img/en.png"
                            alt="English"
                            title="Change Language"
                          />
                        </button>
                        <button
                          type="button"
                          :class="[{active: language == 'es'}, 'btn']"
                          @click.prevent="changeLanguage('es')"
                        >
                          <img
                            class="center-block"
                            src="/static/img/es.png"
                            alt="Spanish"
                            title="Change Language"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="user-footer">
                  <div class="pull-right">
                    <a @click="$store.dispatch('logout')" class="btn btn-danger">
                      {{translate('logout') }}
                      <i class="fa fa-power-off"></i>
                    </a>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <aside :class="['main-sidebar', $store.getters.env]">
      <section class="sidebar">
        <div class="user-panel">
          <div class="pull-left image">
            <img :src="'/static/img/' + user_image " class="img-circle" alt="User Image" />
          </div>
          <div class="pull-left info">
            <div>
              <p>{{ user.company}}</p>
            </div>
            <a href="javascript:;">
              <i class="fa fa-circle text-success glow"></i>
              {{ user.username }}
            </a>
          </div>
        </div>
        <form @submit.prevent="$router.push('/orders/' + goto)" class="sidebar-form">
          <div class="input-group">
            <input
              type="text"
              name="search"
              id="gotoOrder"
              class="search form-control"
              data-toggle="hideseek"
              :placeholder="'goto_order' | translate(language) "
              v-model="goto"
            />
            <span class="input-group-btn">
              <button type="submit" name="search" id="gotoOrder-btn" class="btn btn-flat">
                <i class="fa fa-search"></i>
              </button>
            </span>
          </div>
        </form>
        <form @submit.prevent="goToMp()" class="sidebar-form">
          <div class="input-group">
            <input
              type="text"
              name="search"
              id="gotoMPOrder"
              class="search form-control"
              data-toggle="hideseek"
              placeholder="MP ID"
              v-model="gotoMP"
              :disabled="processing.mp"
            />
            <span class="input-group-btn">
              <button
                type="submit"
                name="search"
                id="gotoMPOrder-btn"
                class="btn btn-flat"
                :disabled="processing.mp"
              >
                <i :class="[processing.mp ? 'fa fa-spinner fa-spin' : 'fa fa-search']"></i>
              </button>
            </span>
          </div>
        </form>
        <form @submit.prevent="goToMpIdAddition()" class="sidebar-form">
          <div class="input-group">
            <input
              type="text"
              name="search"
              id="gotoMPAddition"
              class="search form-control"
              data-toggle="hideseek"
              placeholder="MP ID Addition"
              v-model="gotoMPAddition"
              :disabled="processing.mpAdd"
            />
            <span class="input-group-btn">
              <button
                type="submit"
                name="search"
                id="gotoMPAddition-btn"
                class="btn btn-flat"
                :disabled="processing.mp"
              >
                <i :class="[processing.mp ? 'fa fa-spinner fa-spin' : 'fa fa-search']"></i>
              </button>
            </span>
          </div>
        </form>
        <form @submit.prevent="findOrder('shipping', gotoShipping)" class="sidebar-form">
          <div class="input-group">
            <input
              type="text"
              name="search"
              id="gotoShipping"
              class="search form-control"
              :disabled="processing.shipping"
              data-toggle="hideseek"
              placeholder="Shipping ID"
              v-model="gotoShipping"
            />
            <span class="input-group-btn">
              <button
                type="submit"
                name="search"
                id="gotoShipping-btn"
                class="btn btn-flat"
                :disabled="processing.shipping"
              >
                <i :class="[processing.shipping ? 'fa fa-spinner fa-spin' : 'fa fa-search']"></i>
              </button>
            </span>
          </div>
        </form>
        <form @submit.prevent="findOrder('line', gotoLine)" class="sidebar-form">
          <div class="input-group">
            <input
              type="text"
              name="search"
              id="gotoLine"
              class="search form-control"
              :disabled="processing.line"
              data-toggle="hideseek"
              placeholder="Line ID"
              v-model="gotoLine"
            />
            <span class="input-group-btn">
              <button
                type="submit"
                name="search"
                id="gotoLine-btn"
                class="btn btn-flat"
                :disabled="processing.line"
              >
                <i :class="[processing.line ? 'fa fa-spinner fa-spin' : 'fa fa-search']"></i>
              </button>
            </span>
          </div>
        </form>
        <ul class="sidebar-menu">
          <li :class="{ active: $route.path === '/home' }" @click="toggleMenu">
            <router-link to="/home">
              <i class="fa fa-dashboard"></i>
              <span class="page">{{translate('dashboard') | capitalize}}</span>
            </router-link>
          </li>
          <li
            v-if="$store.dispatch('checkPermissions', 'service')"
            :class="{ active: $route.path.substr(0, 7)  === '/orders', pageLink: true }"
            @click="toggleMenu"
          >
            <router-link to="/orders" id="orders">
              <i class="fa fa-tags"></i>
              <span class="page">{{translate('orders') }}</span>
            </router-link>
          </li>
          <li
            v-if="$store.dispatch('checkPermissions', 'service')"
            :class="{ active: $route.path.substr(0, 7)  === '/reserv'}"
            @click="toggleMenu"
          >
            <router-link to="/reservations">
              <i class="fa fa-tags"></i>
              <span class="page">Click&Collect</span>
              <span class="pull-right-container">
                <small class="label pull-right bg-success">
                  <span v-if="ccCount">{{ccCount}}</span>
                  <i class="fa fa-spinner fa-spin" v-else></i>
                </small>
              </span>
            </router-link>
          </li>
          <li
            v-if="$store.dispatch('checkPermissions', 'service')"
            :class="{ active: $route.path.substr(0, 11) === '/statistics', treeview: true}"
          >
            <a class="collapsable" href="#" id="statistics">
              <i class="fa fa-line-chart"></i>
              <span>{{'statistics' | translate(language) | capitalize}}</span>
              <span class="pull-right-container">
                <span class="sub-indicate"></span>
              </span>
            </a>
            <ul class="treeview-menu">
              <li
                :class="{ active: $route.path === '/statistics/product', pageLink: true, leaf: true, hidden: false}"
                @click="toggleMenu"
              >
                <router-link to="/statistics/product" id="productStats">
                  <i class="fa fa-bar-chart mr-5"></i>
                  <span class="page leaf">{{'product_stats' | translate(language)}}</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/statistics/merchant', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/statistics/merchant" id="merchantStats">
                  <i class="fa fa-bar-chart mr-5"></i>
                  <span class="page leaf">{{'merchant_stats' | translate(language) | capitalize}}</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/statistics/topseller', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/statistics/topseller" id="topseller">
                  <i class="fa fa-money mr-5"></i>
                  <span class="page leaf">{{'top_seller' | translate(language) | capitalize}}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li
            v-if="$store.dispatch('checkPermissions', 'admin')"
            :class="{ active: $route.path.substr(0, 11) === '/monitoring', treeview: true}"
          >
            <a class="collapsable" href="#" id="monitoring">
              <i class="fa fa-television"></i>
              <span>{{'monitoring' | translate(language) | capitalize}}</span>
              <span class="pull-right-container">
                <span class="sub-indicate"></span>
              </span>
            </a>
            <ul class="treeview-menu">
              <li
                :class="{ active: $route.path === '/monitoring/jobs', pageLink: true, leaf: true, hidden: false}"
                @click="toggleMenu"
              >
                <router-link to="/monitoring/jobs" id="jobs">
                  <i class="fa fa-television"></i>
                  <span class="page leaf">{{'jobs' | translate(language)}}</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/sap/monitoring/jobs', pageLink: true, leaf: true, hidden: false}"
                @click="toggleMenu"
              >
                <router-link to="/sap/monitoring/jobs" id="sapJobs">
                  <i class="fa fa-bookmark"></i>
                  <span class="page leaf">{{'sap_jobs' | translate(language)}}</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/monitoring/errors', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/monitoring/errors" id="errors">
                  <i class="fa fa-warning text-danger"></i>
                  <span class="page leaf">{{'order_errors' | translate(language) | capitalize}}</span>
                  <span class="pull-right-container">
                    <small class="label pull-right bg-danger">
                      <span v-if="orderErrorCount">{{orderErrorCount}}</span>
                      <i class="fa fa-spinner fa-spin" v-else></i>
                    </small>
                  </span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/monitoring/labels', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/monitoring/labels" id="labels">
                  <i class="fa fa-paper-plane text-info"></i>
                  <span class="page leaf">{{'label_errors' | translate(language) | capitalize}}</span>
                  <span class="pull-right-container">
                    <small class="label pull-right bg-info">
                      <span v-if="labelErrorCount">{{labelErrorCount}}</span>
                      <i class="fa fa-spinner fa-spin" v-else></i>
                    </small>
                  </span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/monitoring/news', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/monitoring/news" id="news">
                  <i class="fa fa-bell text-warning"></i>
                  <span class="page leaf">{{'notifications' | translate(language) | capitalize}}</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/monitoring/logs', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/monitoring/logs" id="logs">
                  <i class="fa fa-th-list"></i>
                  <span class="page leaf">ErrorLogs</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/monitoring/statistics', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/monitoring/statistics" id="monitoringStatistics">
                  <i class="fa fa-line-chart"></i>
                  <span class="page leaf">Statistics Monitoring</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/monitoring/brands', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/monitoring/brands" id="monitoringBrands">
                  <i class="fa fa-tag"></i>
                  <span class="page leaf">Brands Monitoring</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li
            v-if="$store.dispatch('checkPermissions', 'admin')"
            :class="{ active: $route.path.substr(0, 11) === '/controllin' || $route.path === '/fibu', treeview: true}"
          >
            <a class="collapsable" href="#" id="controlling">
              <i class="fa fa-bank"></i>
              <span>Controlling</span>
              <span class="pull-right-container">
                <span class="sub-indicate"></span>
              </span>
            </a>
            <ul class="treeview-menu">
              <li
                :class="{ active: $route.path === '/controlling/stats', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/controlling/stats" id="stats">
                  <i class="fa fa-bar-chart mr-5"></i>
                  <span class="page leaf">{{'controlling_stats' | translate(language) | capitalize}}</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/fibu', pageLink: true, leaf: true }"
                @click="toggleMenu"
              >
                <router-link to="/fibu">
                  <i class="fa fa-clone mr-5"></i>
                  <span class="page leaf">{{'fibu' | translate}}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li :class="{ active: $route.path === '/labels' }" @click="toggleMenu">
            <router-link to="/labels">
              <i class="fa fa-clone"></i>
              <span class="page">Labels</span>
            </router-link>
          </li>
          <li
            v-if="$store.dispatch('checkPermissions', 'admin')"
            :class="{ active: $route.path.substr(0, 9) === '/overview', treeview: true}"
          >
            <a class="collapsable" href="#" id="overview">
              <i class="fa fa-eye"></i>
              <span>{{'overview' | translate(language)}}</span>
              <span class="pull-right-container">
                <span class="sub-indicate"></span>
              </span>
            </a>
            <ul class="treeview-menu">
              <li
                :class="{ active: $route.path === '/overview/sap', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/overview/sap" id="overviewSap">
                  <i class="fa fa-bookmark text-primary"></i>
                  <span class="page leaf">SAP</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/overview/orders', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/overview/orders" id="overviewOrders">
                  <i class="fa fa-tags text-info mr-5"></i>
                  <span class="page leaf">{{'orders' | translate | capitalize}}</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/overview/unknown', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/overview/unknown" id="overviewUnknown">
                  <i class="fa fa-warning text-danger mr-5"></i>
                  <span class="page leaf">{{'status_unknown' | translate}}</span>
                </router-link>
              </li>
              <li :class="{ active: $route.path === '/overview/complaints', pageLink: true, leaf: true}" @click="toggleMenu">
                <router-link to="/overview/complaints" id="overviewComplaints">
                  <i class="fa fa-bell text-danger mr-5"></i>
                  <span class="page leaf">{{'complaints' | translate}}</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/overview/returns', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/overview/returns" id="overviewReturns">
                  <i class="fa fa-retweet text-warning mr-5"></i>
                  <span class="page leaf">{{'returns' | translate}}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li
              v-if="$store.dispatch('checkPermissions', 'admin')"
              :class="{ active: $route.path.substr(0, 10) === '/ecommerce', treeview: true}"
          >
            <a class="collapsable" href="#" id="ecommerce">
              <i class="fa fa-bar-chart"></i>
              <span>{{'ecommerce' | translate(language)}}</span>
              <span class="pull-right-container">
                <span class="sub-indicate"></span>
              </span>
            </a>
            <ul class="treeview-menu">
              <li
                  :class="{ active: $route.path === '/ecommerce/categories', pageLink: true, leaf: true}"
                  @click="toggleMenu"
              >
                <router-link to="/ecommerce/categories" id="ecommerceCategories">
                  <i class="fa fa-creative-commons mr-5"></i>
                  <span class="page leaf">{{'categories' | translate}}</span>
                </router-link>
              </li>
              <li
                  :class="{ active: $route.path === '/ecommerce/brands', pageLink: true, leaf: true}"
                  @click="toggleMenu"
              >
                <router-link to="/ecommerce/brands" id="ecommerceBrands">
                  <i class="fa fa-creative-commons mr-5"></i>
                  <span class="page leaf">{{'brands' | translate}}</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/ecommerce/articles', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/ecommerce/articles" id="ecommerceProducts">
                  <i class="fa fa-creative-commons mr-5"></i>
                  <span class="page leaf">{{'articles' | translate}}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li
            v-if="$store.dispatch('checkPermissions', 'service')"
            class="header"
          >{{'administration' | translate(language)}}</li>
          <li
            v-if="$store.dispatch('checkPermissions', 'service')"
            :class="{ active: $route.path.substr(0, 16) === '/accounting/comp', pageLink: true}"
            @click="toggleMenu"
          >
            <router-link to="/accounting/companies">
              <i class="fa fa-building-o"></i>
              <span class="page">{{'companies' | translate(language) | capitalize}}</span>
            </router-link>
          </li>
          <li
            v-if="$store.dispatch('checkPermissions', 'service')"
            :class="{ active: $route.path.substr(0, 14) === '/accounting/in', treeview: true}"
          >
            <a href="#">
              <i class="fa fa-television"></i>
              <span>{{'invoices' | translate(language) | capitalize}}</span>
              <span class="pull-right-container">
                <span class="sub-indicate"></span>
              </span>
            </a>
            <ul class="treeview-menu">
              <li
                :class="{ active: $route.path === '/download/invoices/customers', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/download/invoices/customers">
                  <i class="fa fa-file-pdf-o"></i>
                  <span class="page leaf">{{'customer_invoices' | translate(language) | capitalize}}</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/download/invoices/merchants', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/download/invoices/merchants">
                  <i class="fa fa-file-pdf-o"></i>
                  <span class="page leaf">{{'merchant_invoices' | translate(language) | capitalize}}</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/download/sap/invoices/customers', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/download/sap/invoices/customers">
                  <i class="fa fa-file-pdf-o"></i>
                  <span
                    class="page leaf"
                  >{{'sap_customer_invoices' | translate(language) | capitalize}}</span>
                </router-link>
              </li>
              <li
                :class="{ active: $route.path === '/download/sap/invoices/merchants', pageLink: true, leaf: true}"
                @click="toggleMenu"
              >
                <router-link to="/download/sap/invoices/merchants">
                  <i class="fa fa-file-pdf-o"></i>
                  <span
                    class="page leaf"
                  >{{'sap_merchant_invoices' | translate(language) | capitalize}}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li
            v-if="$store.dispatch('checkPermissions', 'service')"
            :class="{ active: $route.path.substr(0, 7)  === '/upload', pageLink: true }"
            @click="toggleMenu"
          >
            <router-link to="/upload" id="upload">
              <i class="fa fa-upload"></i>
              <span class="page">Upload</span>
            </router-link>
          </li>
          <li
            v-if="$store.dispatch('checkPermissions', 'admin')"
            class="header"
          >{{'Financial'|translate(language)}}</li>
          <li
            v-if="$store.dispatch('checkPermissions', 'admin')"
            :class="{ active: $route.path.substr(0, 5)  === '/avis', pageLink: true }"
            @click="toggleMenu"
          >
            <router-link to="/avis" id="avisUpload">
              <i class="fa fa-upload"></i>
              <span class="page">{{"Avis Upload"|translate(language)}}</span>
            </router-link>
          </li>
          <li
            v-if="$store.dispatch('checkPermissions', 'admin')"
            :class="{ active: $route.path.substr(0, 5)  === '/avis', pageLink: true }"
            @click="toggleMenu"
          >
            <router-link to="/sapCollectionInvoiceAnalyses" id="collectionInvoiceAnalyses">
              <i class="fa fa-download"></i>
              <span class="page">{{"collectionInvoiceAnalyses"|translate(language)}}</span>
            </router-link>
          </li>
          <li
            v-if="$store.dispatch('checkPermissions', 'admin')"
            class="header"
          >{{'Configurations'|translate(language)}}</li>
          <li
            v-if="$store.dispatch('checkPermissions', 'admin')"
            :class="{ active: $route.path.substr(0, 7)  === '/sap_conf', pageLink: true }"
            @click="toggleMenu"
          >
            <router-link to="/sapconf/saleschannels" id="sapConfSalesChannel">
              <i class="fa fa-wrench"></i>
              <span class="page">{{"SapSaleschannelConfig"|translate(language)}}</span>
            </router-link>
          </li>
        </ul>
      </section>
    </aside>
    <div class="content-wrapper">
      <ranking-modal></ranking-modal>
      <section class="content-header">
        <h1 class="pageTitle" id="pageTitle">{{translate($route.name) || $route.name}}</h1>
        <ol class="breadcrumb">
          <li>
            <a href="javascript:;">
              <i class="fa fa-dashboard"></i>Dashboard
            </a>
          </li>
          <template v-if="$route.path !== '/home'" v-for="path in pathsGenerator()">
            <li class="active">{{translate(path) || path}}</li>
          </template>
        </ol>
        <!-- NEW ALERTS -->
        <template v-for="alert in $store.getters.alerts">
          <b-alert
            :show="alert.dismiss"
            dismissible
            :variant="alert.type"
            @dismissed="dismissAlert(alert)"
          >
            <h4>
              <i :class="alert.icon"></i>
              {{'alert_'+alert.type | translate}}!
            </h4>
            {{alert.message}}
            <a
              v-if="alert.action"
              class="btn btn-success"
              @click="alert.action"
            >Go to Details</a>
          </b-alert>
        </template>
        <!-- END OF NEW ALERTS -->
      </section>
      <router-view></router-view>
    </div>
    <footer class="main-footer">
      <strong>
        Copyright &copy; {{year}}
        <a href="https://www.anwr-group.com" target="_blank">ANWR Media</a>.
      </strong> All rights reserved.
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      section: "Dash",
      processing: {
        line: false,
        shipping: false,
        mp: false,
        mpAdd: false
      },
      gotoMPAddition: "",
      me: "",
      error: "",
      goto: "",
      alerts: [],
      gotoShipping: "",
      gotoLine: "",
      gotoMP: "",
      ccCount: false,
      labelErrorCount: false,
      orderErrorCount: false,
      count: 0,
      state: this.$store.state,
      user: this.$store.getters.user,
      user_image: "user2-160x160.jpg", // NEED THIS FROM DATABASE
      user_position: "best front-end developer ever", // THIS TOO
      language: this.$store.getters.language,
      translate(word) {
        let trans = this.$options.filters.translate(word, this.language);
        if (trans === "undefined") {
          return false;
        } else {
          return trans;
        }
      }
    };
  },
  computed: {
    classObject() {
      return "pageLink";
    },
    year() {
      let y = new Date();
      return y.getFullYear();
    }
  },
  methods: {
    goToMp() {
      this.processing.mp = true;
      if (this.gotoMP === "") {
        this.processing.mp = false;
        this.$router.push("/orders");
      } else {
        API.get("orders?ext_order_id=" + this.gotoMP).then(response => {
          this.processing.mp = false;
          if (
            response.data.data.length > 1 ||
            response.data.data.length === 0
          ) {
            this.$router.push("/orders/error");
          } else {
            this.$router.push("/orders/" + response.data.data[0].id);
          }
        });
      }
    },
    goToMpIdAddition() {
      this.processing.mpAdd = true;
      if (this.gotoMPAddition === "") {
        this.processing.mpAdd = false;
        this.$router.push("/orders");
      } else {
        API.get("orders?ext_order_id_addition=" + this.gotoMPAddition).then(
          response => {
            this.processing.mpAdd = false;
            if (
              response.data.data.length > 1 ||
              response.data.data.length === 0
            ) {
              this.$router.push("/orders/error");
            } else {
              this.$router.push("/orders/" + response.data.data[0].id);
            }
          }
        );
      }
    },
    findOrder(type, id) {
      this.processing[type] = true;
      if (id === "") {
        this.$router.push("/orders")
        this.processing[type] = false
      } else {
        API.get(`/orders/find/${type}/${id}`)
          .then(res => {
            this.$router.push(`/orders/${res.data.order_id}`)
            this.processing[type] = false
          })
          .catch(error => {
            let alert = {
              type: "danger",
              dismiss: 4,
              message: `Order not found for ${type}-ID ${id}`,
              icon: "icon fa fa-ban"
            };
            this.$store.commit("pushAlert", alert);
            this.processing[type] = false
          })
      }
    },
    pathsGenerator() {
      let paths = this.$route.path.split("/");
      paths.shift();
      return paths;
    },
    checkEnv() {
      return (
        ["cs.qb-schuhe.de", "www.cs.qb-schuhe.de"].indexOf(
          window.location.hostname
        ) !== -1
      );
    },
    checkRole(role) {
      let roles = JSON.parse(window.localStorage.getItem("roles"));
      return roles.admin || roles[role];
    },
    changeLanguage(lang) {
      this.$store.commit("updateLanguage", lang);
      this.language = lang;
    },
    toggleMenu(event) {
      $("li.pageLink").removeClass("active");
      if (
        !event.target.classList.contains("leaf") &&
        !event.target.parentElement.classList.contains("leaf")
      ) {
        $("li.treeview").removeClass("active");
        if ($("ul.treeview-menu.menu-open").length > 0) {
          $("ul.treeview-menu.menu-open")[0].previousElementSibling.click();
        }
      }
      event.target.parentElement.className = "pageLink active";
    },
    dismissAlert(alert) {
      this.$store.commit("removeAlert", alert);
    }
  },
  mounted() {
    this.user = this.$store.getters.user;
    let a = 0;
    this.$store.dispatch("checkPermissions", "dashboard");
    API.get("statistics/companies").then(res => {
      this.$store.commit("updateCompanies", res.data);
      API.get("/clickAndCollect/reservations/count").then(res => {
        this.ccCount = res.data.amount;
      });
      if (this.user.roles.admin) {
        API.get("/monitoring/labels/failed").then(res => {
          this.labelErrorCount = res.data.length;
        });
        API.get("/monitoring/order/failed").then(res => {
          a = res.data.length;
          API.get("/monitoring/order/canceled").then(res => {
            this.orderErrorCount = res.data.length + a;
          });
        });
      }
    });
  }
};
</script>
<style scoped>
.staging {
  background-color: #5b4094 !important;
}
.dev {
  background-color: #136178 !important;
}
.logo-st {
  width: 70%;
  -webkit-animation: spin 4s linear infinite;
  -moz-animation: spin 4s linear infinite;
  animation: spin 4s linear infinite;
}
@-moz-keyframes spin {
  100% {
    -moz-transform: rotateY(360deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotateY(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotateY(360deg);
    transform: rotateY(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue